import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const StripeCheckoutForm = ({ onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);
    setError(null);

    try {
      const res = await fetch('/api/create-payment-intent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: 3500, currency: 'usd' }) // $35.00
      });

      if (!res.ok) throw new Error('Failed to create payment intent');
      const { clientSecret } = await res.json();

      const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: { card: elements.getElement(CardElement) }
      });

      if (stripeError) {
        setError(stripeError.message);
        setProcessing(false);
      } else if (paymentIntent.status === 'succeeded') {
        if (onSuccess) onSuccess(paymentIntent);
      }
    } catch (err) {
      setError(err.message);
      setProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ padding: '1rem', background: 'white', borderRadius: '8px', marginBottom: '1rem' }}>
        <CardElement options={{ style: { base: { fontSize: '16px' } } }} />
      </div>
      {error && <div style={{ color: '#D94F2B', marginBottom: '1rem', fontSize: '0.9rem' }}>{error}</div>}
      <button 
        disabled={!stripe || processing} 
        style={{ 
          width: '100%', 
          padding: '1rem', 
          background: 'linear-gradient(135deg, #F5A623, #D94F2B)', 
          border: 'none', 
          borderRadius: '50px', 
          color: '#1A1A1A', 
          fontWeight: 700, 
          fontSize: '1.1rem',
          cursor: processing ? 'not-allowed' : 'pointer',
          opacity: processing ? 0.7 : 1,
          transition: 'transform 0.2s'
        }}
      >
        {processing ? 'Processing...' : 'Pay $35'}
      </button>
    </form>
  );
};

const StripeForm = ({ publicKey, onSuccess }) => {
  if (!publicKey) return <div style={{ color: 'red' }}>Stripe Public Key Missing</div>;
  
  const stripePromise = loadStripe(publicKey);
  return (
    <Elements stripe={stripePromise}>
      <StripeCheckoutForm onSuccess={onSuccess} />
    </Elements>
  );
};

export default StripeForm;
